import { render, staticRenderFns } from "./DocumentationIndex.vue?vue&type=template&id=30b5dca2&"
import script from "./DocumentationIndex.vue?vue&type=script&lang=js&"
export * from "./DocumentationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports